import React from "react";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";
import { Grid, Dialog, DialogContent } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { IValuesStore } from "Stores/Values/types";
import AddIcon from "@material-ui/icons/Add";
import { Values } from "@src/Tools/Values";
import OAuthApiTokenForm from "../AuthApiTokenForm/AuthApiTokenForm";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";
import { IUserApiTokenInfo } from "@src/Interfaces/Entity/UserApiToken";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
class AddAuthApiToken extends React.Component<IProps> {
  @observable opened: boolean = false;

  handleOpen = () => {
    this.opened = true;
  };

  handleClose = () => {
    this.opened = false;
  };

  handleCreate = async (values: IUserApiTokenInfo) => {
    try {
      await this.props.management.generateuUserApiToken(values.name);
      this.handleClose();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const initialValues: IUserApiTokenInfo = {
      id: '',
      createdOn: new Date(),
      name: '',
      userId: '',
      expiresAt: new Date(),
      lastUsed: new Date(),
      isReceived: false
    };
    return (
      <Grid item>
        <RoundButton
          icon={<AddIcon/>}
          tooltipTitle={Values.getLocalizationValue("add")}
          onClick={() => this.handleOpen()}
          color={"green"}
        />
        
        <Dialog
          open={this.opened}
          onClose={this.handleClose}
        >
          <DialogContent>
            <OAuthApiTokenForm
              title={Values.getLocalizationValue("add")}
              initialValues={initialValues}
              onSubmit={this.handleCreate}
              onClose={this.handleClose}
              infoWindow={false}
            />
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }
}

export default AddAuthApiToken;
